import { useEffect } from "react";
function navigatesAway(event: MouseEvent): boolean {
  const anchor = (event.target as Element)?.closest?.(
    "a[href]"
  ) as HTMLAnchorElement | null;
  if (!anchor) return false;
  if (anchor.target === "_blank") return false;
  if (event.button !== 0) return false;
  if (
    [event.ctrlKey, event.metaKey, event.shiftKey, event.altKey].some(Boolean)
  )
    return false;
  const url = new URL(anchor.href, window.location.href);
  return (
    url.pathname !== window.location.pathname ||
    url.search !== window.location.search
  );
}
export default function useRecipeNavigationGuard(
  dirty: boolean,
  saving: boolean
) {
  useEffect(() => {
    if (!dirty && !saving) return;
    const unload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    const navigate = (event: MouseEvent) => {
      if (!navigatesAway(event)) return;
      const message = saving
        ? "A recipe request is in progress. Leave this page?"
        : "Leave with unsaved recipe changes? Your draft will remain in this browser tab when browser storage is available.";
      if (!window.confirm(message)) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    window.addEventListener("beforeunload", unload);
    document.addEventListener("click", navigate, true);
    return () => {
      window.removeEventListener("beforeunload", unload);
      document.removeEventListener("click", navigate, true);
    };
  }, [dirty, saving]);
}
